import { Quote, Star } from "lucide-react";
import { useApp } from "@/lib/i18n";

const initials = (n) => n.replace(/^(Dr\.|Prof\.)\s*/i, "").split(/\s+/).slice(0, 2).map((w) => w[0]).join("").toUpperCase();

const Card = ({ t, i }) => {
  const { L } = useApp();
  return (
    <figure className="flex w-[300px] shrink-0 flex-col rounded-3xl border border-slate-200 bg-white p-6 shadow-sm sm:w-[380px]" data-testid={`testimonial-card-${i}`}>
      <Quote size={26} className="fill-violet-100 text-violet-300" />
      <blockquote className="mt-4 flex-1 text-sm leading-relaxed text-slate-700 sm:text-base">{L(t.quote_ms, t.quote_en || t.quote_ms)}</blockquote>
      <figcaption className="mt-6 flex items-center gap-3 border-t border-slate-100 pt-5">
        <span className="grid h-11 w-11 shrink-0 place-items-center rounded-full bg-violet-100 text-sm font-bold text-violet-700">{initials(t.name)}</span>
        <span className="min-w-0 flex-1"><span className="block truncate font-semibold text-slate-900">{t.name}</span><span className="block truncate text-xs text-slate-500">{t.role}</span></span>
        <span className="flex shrink-0" aria-label={`${t.rating}/5`}>{[1, 2, 3, 4, 5].map((n) => <Star key={n} size={14} className={n <= t.rating ? "fill-amber-400 text-amber-400" : "text-slate-200"} />)}</span>
      </figcaption>
    </figure>
  );
};

const Row = ({ items, offset, reverse }) => (
  <div className="marquee overflow-hidden [mask-image:linear-gradient(to_right,transparent,black_6%,black_94%,transparent)]">
    <div className={`marquee-track flex w-max gap-5 py-2 ${reverse ? "marquee-reverse" : ""}`}>
      {[...items, ...items].map((t, i) => <Card key={i} t={t} i={offset + (i % items.length)} />)}
    </div>
  </div>
);

export const Testimonials = () => {
  const { L, config } = useApp();
  const data = config.testimonials;
  if (!data?.items?.length) return null;
  const half = Math.ceil(data.items.length / 2);
  return (
    <section className="py-20 sm:py-24" data-testid="testimonials-section">
      <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8">
        <p className="text-sm font-semibold uppercase tracking-wider text-violet-700">{L("Testimoni", "Testimonials")}</p>
        <h2 className="mt-3 text-3xl font-extrabold tracking-tight sm:text-4xl">{L("Apa kata pengguna MinitAI", "What MinitAI users say")}</h2>
      </div>
      <div className="mt-12 space-y-5">
        <Row items={data.items.slice(0, half)} offset={0} />
        {data.items.length > half && <Row items={data.items.slice(half)} offset={half} reverse />}
      </div>
      {data.is_sample && <p className="mt-8 px-4 text-center text-xs text-slate-400" data-testid="testimonials-sample-label">{L("Contoh testimoni — akan digantikan dengan ulasan pengguna sebenar.", "Sample testimonials — to be replaced with real user reviews.")}</p>}
    </section>
  );
};
